import React from 'react';

const RevalidationHistoryItem = (params) => {
    return (
        <div className="card" style={{ maxWidth: "750px" }}>
            <h5 className="card-header py-3">
                <i className="fa fa-folder-open-o" aria-hidden="true"></i> Revalidation History
            </h5>
            <div className="card-body">
                <div className="ag-theme-alpine">
                    <div style={{ backgroundColor: 'white', marginBottom: "15px" }}>
                        <div className="row">
                            <div className="col-md-6">
                                <b>Email:</b> {params.data.userEmail}
                            </div>
                            <div className="col-md-6">
                                <b>Application Name:</b> {params.data.applicationName}
                            </div>                            
                        </div>
                        <br />
                        <div className="row">
                            <div className="col-md-6">
                                <b>Manager Email:</b> {params.data.managerEmail}
                            </div>
                            <div className="col-md-6">
                                <b>Version:</b> {params.data.version}
                            </div>
                        </div>
                        <br />
                        <div className="row">
                            <div className="col-md-6">
                                <b>Modified Date:</b> {params.data.createdDate}
                            </div>
                            <div className="col-md-6">
                                <b>Current Status:</b> {params.data.currentStatus}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="card-footer text-muted">
                <div style={{ textAlign: "center" }}>
                    <button className="btn btn-secondary" onClick={params.onClose}>Close</button>
                </div>
            </div>
        </div>
    );
};

export default RevalidationHistoryItem;